import { render } from "./scoreOpe.vue?vue&type=template&id=592f5061&scoped=true"
import script from "./scoreOpe.vue?vue&type=script&lang=js"
export * from "./scoreOpe.vue?vue&type=script&lang=js"

import "./scoreOpe.vue?vue&type=style&index=0&id=592f5061&lang=less&scoped=true"

import exportComponent from "/dev/shm/repo/piano-dp8c0m8ga1zm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-592f5061"]])

export default __exports__